import React from 'react';

const Error = ({children}) => {
    return (
        <div className={'error'}>
            {children}
        </div>
    );
};

export default Error;